import { render, staticRenderFns } from "./eventListAdd.vue?vue&type=template&id=4a8d36fa&scoped=true"
import script from "./eventListAdd.vue?vue&type=script&lang=js"
export * from "./eventListAdd.vue?vue&type=script&lang=js"
import style0 from "./eventListAdd.vue?vue&type=style&index=0&id=4a8d36fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d36fa",
  null
  
)

export default component.exports